import "./Solutions.module.css";
import Header from "@/reusable_sections/Header";
import FeaturedSolutionsHub from "./sections/FeaturedSolutionsHub";
import SolutionsDeepDive from "./sections/SolutionsDeepDive";
import CommonSolutionsQuestions from "./sections/CommonSolutionsQuestions";
import Footer from "@/reusable_sections/Footer";
export default function SolutionsPage() {
  return <div>
      <Header />
      <FeaturedSolutionsHub />
      <SolutionsDeepDive />
      <CommonSolutionsQuestions />
      <Footer />
    </div>;
}